import { createSelector } from 'reselect';
import {
    SUBMIT_PRE_VET_FORM,
    SUBMIT_PRE_VET_FORM_SUCCESS,
    SUBMIT_PRE_VET_FORM_FAILURE,
    CLEAR_PRE_VET_FORM_ERROR,
    RESET_PRE_VET_FORM,
    SUBMIT_PRE_VET_FORM_LOADING,
    UPDATE_PREVET_FORM,
    UPDATE_PREVET_FORM_LOADING,
    UPDATE_PREVET_FORM_SUCCESS,
    UPDATE_PREVET_FORM_FAILURE
} from './prevetFormActions';

const initialState = {
    isSubmitting: false,
    error: null,
    submitSuccess: false,
    prevetId: null,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
    updatePrevetId: null
};

export default function prevetFormReducer(state = initialState, action = {}) {
    let newState;

    switch (action.type) {
        case SUBMIT_PRE_VET_FORM:
            newState = {
                ...state,
                isSubmitting: true,
                error: null,
                submitSuccess: false
            };

            return newState;

        case SUBMIT_PRE_VET_FORM_SUCCESS: {
            let prevetId = null;

            if (action.response) {
                if (action.response.prevetId !== undefined && action.response.prevetId !== null) {
                    prevetId = action.response.prevetId;
                }
            }

            newState = {
                ...state,
                isSubmitting: true, // Keep submitting true for polling
                error: null,
                submitSuccess: true,
                prevetId: prevetId
            };

            return newState;
        }

        case SUBMIT_PRE_VET_FORM_FAILURE:
            newState = {
                ...state,
                isSubmitting: false,
                error: action.error,
                submitSuccess: false
            };

            return newState;

        case CLEAR_PRE_VET_FORM_ERROR:
            newState = {
                ...state,
                error: null
            };

            return newState;

        case RESET_PRE_VET_FORM:
            return initialState;

        case SUBMIT_PRE_VET_FORM_LOADING:
            newState = {
                ...state,
                isSubmitting: true
            };

            return newState;

        case UPDATE_PREVET_FORM:
            newState = {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };

            return newState;

        case UPDATE_PREVET_FORM_LOADING:
            newState = {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };

            return newState;

        case UPDATE_PREVET_FORM_SUCCESS: {
            let prevetId = null;

            if (action.response) {
                if (action.response.prevetId !== undefined && action.response.prevetId !== null) {
                    prevetId = action.response.prevetId;
                }
            }

            newState = {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: true,
                updatePrevetId: prevetId
            };

            return newState;
        }

        case UPDATE_PREVET_FORM_FAILURE:
            newState = {
                ...state,
                updateLoading: false,
                updateError: action.error,
                updateSuccess: false
            };

            return newState;

        default:
            return state;
    }
}

const getPrevetFormState = (state) => {
    return state.entities?.prevetForm || initialState;
};

export const getIsPrevetFormSubmitting = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.isSubmitting
);

export const getPrevetFormError = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.error
);

export const getPrevetFormSubmitSuccess = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.submitSuccess
);

export const getPrevetFormPrevetId = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.prevetId
);

export const getIsPrevetFormUpdateLoading = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.updateLoading
);

export const getPrevetFormUpdateError = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.updateError
);

export const getIsPrevetFormUpdateSuccess = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.updateSuccess
);

export const getPrevetFormUpdatePrevetId = createSelector(
    [getPrevetFormState],
    (prevetFormState) => prevetFormState.updatePrevetId
);
